import moment from "moment";

const TOKEN_KEY = "safetywiseapiToken_v3";
const TOKEN_EXPIRY_KEY = "safetywiseapiTokenExpiry_v3";
const IMPERSONATION_TOKEN_KEY = "safetywiseapiImpersonationToken";
const IMPERSONATION_TOKEN_EXPIRY_KEY = "safetywiseapiImpersonationTokenExpiry";

const isExpiryValid = (tokenExpiryTimestamp) => {
	if (!tokenExpiryTimestamp) return false;
	const nowValue = moment().valueOf();
	const expiryValue = parseInt(tokenExpiryTimestamp, 10);
	return Number.isFinite(expiryValue) && expiryValue > nowValue;
};

export const tokenExists = () => {
	let token = getToken();
	if (!token) {
		return false;
	}

	let tokenExpiryTimestamp = getTokenExpiry();
	if (!tokenExpiryTimestamp) {
		return false;
	}

	return isExpiryValid(tokenExpiryTimestamp);
};

export const getToken = () => {
	const impersonationToken = localStorage.getItem(IMPERSONATION_TOKEN_KEY);
	const impersonationTokenExpiry = localStorage.getItem(
		IMPERSONATION_TOKEN_EXPIRY_KEY
	);

	// Only use impersonation token if it has a valid, unexpired expiry timestamp.
	// If it's stale (e.g., expiry missing), clear it so we can fall back to the real token.
	if (impersonationToken && isExpiryValid(impersonationTokenExpiry)) {
		return impersonationToken;
	} else if (impersonationToken) {
		localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
		localStorage.removeItem(IMPERSONATION_TOKEN_EXPIRY_KEY);
	}

	const token = localStorage.getItem(TOKEN_KEY);

	return token || null;
};

export const getTokenExpiry = () => {
	const impersonationTokenExpiry = localStorage.getItem(
		IMPERSONATION_TOKEN_EXPIRY_KEY
	);

	if (impersonationTokenExpiry) {
		return impersonationTokenExpiry;
	}

	const tokenExpiry = localStorage.getItem(TOKEN_EXPIRY_KEY);

	return tokenExpiry || null;
};

export const setToken = (token, expiresInSeconds) => {
	localStorage.setItem(TOKEN_KEY, token);
	localStorage.setItem(
		TOKEN_EXPIRY_KEY,
		moment().add(expiresInSeconds, "seconds").valueOf()
	);
};

export const setImpersonationToken = (token, expiresInSeconds) => {
	localStorage.setItem(IMPERSONATION_TOKEN_KEY, token);
	localStorage.setItem(
		IMPERSONATION_TOKEN_EXPIRY_KEY,
		moment().add(expiresInSeconds, "seconds").valueOf()
	);
};

export const clearToken = () => {
	localStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(TOKEN_EXPIRY_KEY);
};

export const clearImpersonationToken = () => {
	localStorage.removeItem(IMPERSONATION_TOKEN_KEY);
	localStorage.removeItem(IMPERSONATION_TOKEN_EXPIRY_KEY);
};

export const isInImpersonationMode = () => {
	return !!localStorage.getItem(IMPERSONATION_TOKEN_KEY);
};
